var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNote1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.3345V5.70043C9.5 5.27992 9.76307 4.90434 10.1583 4.76064L13.6583 3.48791C14.3104 3.25075 15 3.73374 15 4.4277V6.307C15 6.72385 14.7414 7.09697 14.3511 7.24333L11.3244 8.37834C11.1293 8.45152 11 8.63808 11 8.8465V14.5C11 15.8807 9.65685 17 8 17C6.34315 17 5 15.8807 5 14.5C5 13.1193 6.34315 12 8 12C8.54643 12 9.05874 12.1217 9.5 12.3345Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote1);
export default __webpack_public_path__ + "static/media/music-note-1.588359fee7dc6ba80697458df9258702.svg";
export { ForwardRef as ReactComponent };